import {
  BenefitCopyDataType,
  CoverAreaDataType,
  CoverDrawerDetailsDataType,
  CoverLevelItemDataType,
  QuoteCoverDataType,
} from "@/schema/quote-page/page.schema";

const getBenifitData = (data: Record<string, BenefitCopyDataType>) => {
  const keys = Object.keys(data);
  return keys.map((node) => {
    return {
      description: data[node].description,
      isActive: data[node].isActive,
      isCancelation: data[node].isCancelation,
      isMedicalExpenses: data[node].isMedicalExpenses,
      isExcludeUK: data[node].isExcludeUK,
    };
  });
};

const getCoverDrawerDetailsData = (
  data: Record<string, CoverDrawerDetailsDataType>
) => {
  if (data) {
    const keys = Object.keys(data);
    return keys.map((node) => {
      return {
        benefitTitle: data[node].benefitTitle,
        benefitSubtitle: data[node].benefitSubtitle,
        benefitCopy: data[node].benefitCopy,
        isExcludeUK: data[node].isExcludeUK,
      };
    });
  }
  return [];
};

const getRelatedCoverLevelData = (
  data: Record<string, CoverLevelItemDataType>
) => {
  const keys = Object.keys(data);
  return keys?.map((node) => {
    return {
      coverType: data[node].coverType,
      coverTitle: data[node].coverTitle,
      coverDrawerCopy: data[node].coverDrawerCopy,
      coverDrawerDetails: getCoverDrawerDetailsData(
        data[node].coverDrawerDetails
      ),
      defaqtoRating: data[node].defaqtoRating,
      benifitData: getBenifitData(data[node].benefitCopy),
      whichBestBuyBadge: data[node].whichBestBuyBadgeImage,
    };
  });
};

const getRelatedCoverData = (
  data?: CoverAreaDataType,
  isCruise?: boolean,
  tripType?: string
) => {
  const dataNodes = data?.["0"].quoteCover as unknown as Record<
    string,
    QuoteCoverDataType
  >;
  const keys = Object.keys(dataNodes);
  return keys?.map((node) => {
    const dataSetCoverLevel = dataNodes[node]
      .coverLevelItem as unknown as Record<string, CoverLevelItemDataType>;
    if (
      isCruise === dataNodes[node].isCruise &&
      tripType === dataNodes[node].tripType
    ) {
      return getRelatedCoverLevelData(dataSetCoverLevel);
    }
    return null;
  });
};

export default getRelatedCoverData;
